"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resourceKeys = void 0;
var resourceKeys = {
  charactersRemaining: {
    description: "Number of characters remaining in a field or input box.",
    key: "charactersRemaining"
  },
  showPagesOfTotalItems: {
    description: "Text displaying the range of items being shown out of the total items.",
    key: "showPagesOfTotalItems"
  },
  firstPage: {
    description: "Label for navigating to the first page in a paginated view.",
    key: "firstPage"
  },
  previousPage: {
    description: "Label for navigating to the previous page in a paginated view.",
    key: "previousPage"
  },
  page: {
    description: "Label for individual page navigation in a paginated view.",
    key: "page"
  },
  nextPage: {
    description: "Label for navigating to the next page in a paginated view.",
    key: "nextPage"
  },
  lastPage: {
    description: "Label for navigating to the last page in a paginated view.",
    key: "lastPage"
  },
  selectAction: {
    description: "Prompt for selecting an action from a dropdown or similar interface.",
    key: "selectAction"
  },
  apply: {
    description: "Label for an action button to apply changes or selections.",
    key: "apply"
  },
  loading: {
    description: "Indicator text for loading content or operations in progress.",
    key: "loading"
  },
  readLess: {
    description: "Label to show less content in a collapsible or expandable view.",
    key: "readLess"
  },
  readMore: {
    description: "Label to expand and show more content in a collapsible or expandable view.",
    key: "readMore"
  },
  view: {
    description: "Label for changing display window.",
    key: "view"
  }
};
exports.resourceKeys = resourceKeys;